module.exports = __webpack_public_path__ + "img/list.9d3801a4.svg";